import { Injectable } from '@angular/core';
import { MessageService } from 'primeng/api';
@Injectable({
  providedIn: 'root'
})
export class MessageServiceService {

  constructor(
    private messageService: MessageService,
  ) { }


  showSuccess(toastMessage) {
    this.messageService.add({ summary: toastMessage, severity: 'success', life:10000}); //detail: 'Errors', 
  }

  showWarning(toastMessage) {
    this.messageService.add({ summary: toastMessage, severity: 'warn'});
  }

  showError() {
    this.messageService.add({ summary: "Error occur in server.", severity: 'error',
                                    detail:'please logout and try after some time' });
  }


  showErrorMessage(toastMessage){
    this.messageService.add({ summary: toastMessage, severity: 'error' });
  }

  clear() {
      this.messageService.clear();
  }

  confirmationMessage(description){
    this.messageService.clear();
    this.messageService.add({key: 'c', sticky: true, severity:'warn', summary:'Are you sure?', detail:description});
  }
  

}
